"use strict";

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var support_js_1 = require("./support.js");

var types_js_1 = require("./types.js");

var INDICES = {
  ready: 0,
  enabled: 1
};
var STATES = {
  disabled: 0,
  enabled: 1,
  stopped: 2
};

var VoiceFocusWorkerBufferNode = /*#__PURE__*/function (_types_js_1$VoiceFocu) {
  _inherits(VoiceFocusWorkerBufferNode, _types_js_1$VoiceFocu);

  var _super = _createSuper(VoiceFocusWorkerBufferNode);

  function VoiceFocusWorkerBufferNode(context, options) {
    var _this;

    _classCallCheck(this, VoiceFocusWorkerBufferNode);

    _this = _super.call(this, context, options.processor, options);
    _this.channelCountMode = 'explicit';
    _this.channelCount = 1;
    var modelURL = options.modelURL,
        resamplerURL = options.resamplerURL,
        worker = options.worker,
        fetchBehavior = options.fetchBehavior,
        delegate = options.delegate;
    _this.delegate = delegate;
    _this.worker = worker;
    _this.worker.onmessage = _this.onWorkerMessage.bind(_assertThisInitialized(_this));
    _this.port.onmessage = _this.onProcessorMessage.bind(_assertThisInitialized(_this));
    var _options$processorOpt = options.processorOptions,
        enabled = _options$processorOpt.enabled,
        supportFarendStream = _options$processorOpt.supportFarendStream;

    _this.worker.postMessage({
      message: 'init',
      approach: 'sab',
      frames: context.sampleRate === 16000 ? 160 : 480,
      enabled: enabled,
      model: modelURL,
      supportFarendStream: supportFarendStream
    });

    var message = support_js_1.supportsWASMPostMessage(globalThis) ? 'get-module' : 'get-module-buffer';

    _this.worker.postMessage({
      message: message,
      key: 'resampler',
      fetchBehavior: fetchBehavior,
      path: resamplerURL
    });

    return _this;
  }

  _createClass(VoiceFocusWorkerBufferNode, [{
    key: "enable",
    value: function enable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.state) {
                  Atomics.store(this.state, INDICES.enabled, STATES.enabled);
                  Atomics.notify(this.state, INDICES.ready, 1);
                } else {
                  this.worker.postMessage({
                    message: 'enable'
                  });
                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "disable",
    value: function disable() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.state) {
                  Atomics.store(this.state, INDICES.enabled, STATES.disabled);
                  Atomics.notify(this.state, INDICES.ready, 1);
                } else {
                  this.worker.postMessage({
                    message: 'disable'
                  });
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.state) {
                  Atomics.store(this.state, INDICES.enabled, STATES.stopped);
                  Atomics.notify(this.state, INDICES.ready, 1);
                } else {
                  try {
                    this.worker.postMessage({
                      message: 'stop'
                    });
                  } catch (e) {}
                }

                this.disconnect();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "onWorkerMessage",
    value: function onWorkerMessage(event) {
      var _a;

      var data = event.data;

      switch (data.message) {
        case 'ready':
          if (!data.shared) {
            throw new Error('No shared state.');
          }

          this.state = new Int32Array(data.shared.state);
          this.port.postMessage(data);
          break;

        case 'stopped':
          this.worker.terminate();
          break;

        case 'module-buffer':
        case 'module':
          this.port.postMessage(data);
          break;

        case 'cpu':
          (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onCPUWarning();
          break;

        case 'processing':
          this.port.postMessage(data);
          break;

        default:
          return;
      }
    }
  }, {
    key: "onProcessorMessage",
    value: function onProcessorMessage(event) {
      var _a;

      var data = event.data;

      switch (data.message) {
        case 'cpu':
          (_a = this.delegate) === null || _a === void 0 ? void 0 : _a.onCPUWarning();
          break;

        case 'prepare-for-frames':
          this.worker.postMessage(data);
          break;

        default:
      }
    }
  }]);

  return VoiceFocusWorkerBufferNode;
}(types_js_1.VoiceFocusAudioWorkletNode);

exports.default = VoiceFocusWorkerBufferNode;